import {appendBizParam} from "./m_common/mBizReport"
import {device, checkScreenOrientation, delParam} from './util'


/**
 * 拼接click_url
 * @param {object} defaultCampaign
 * @param {object} clickPosition 点击坐标对象
 * @param {object} bridgeContext v3接口上下文
 */
export function setClickUrl(defaultCampaign, clickPosition, bridgeContext) {
  let _data = bridgeContext;
  const _scale = clickPosition.scale;
  const cdnate_cfg = _data.appSetting.cdnate_cfg;
  let device_width = '';
  let device_height = '';
  if (_data.device) { // 安卓sdk 9.7.0 及以下不返回device字段
      device_width = _data.device.screen_width ? _data.device.screen_width : "";
      device_height = _data.device.screen_height ? _data.device.screen_height : "";
      if (device().isiOS) {
          device_width = (_data.device.device_width ? _data.device.device_width : 0) * _scale;
          device_height = (_data.device.device_width ? _data.device.device_width : 0) * _scale;
      }
  }
  let click_url = defaultCampaign.click_url;
  let rel = /.+:\/\/(.*?)\//;
  let relhost = rel.exec(click_url)
  let host = relhost ? relhost[1] : '';
  let tar = {
      x: parseInt(clickPosition.x),
      y: parseInt(clickPosition.y),
      width: parseInt(device_width || window.screen.width),
      height: parseInt(device_height || window.screen.height)
  }

  if (cdnate_cfg && cdnate_cfg[host]) {
      let item = cdnate_cfg[host];
      for (let k in item) {
          let arr = item[k]
          for (let i = 0; i < arr.length; i++) {
              click_url = click_url.replace(new RegExp(arr[i], 'g'), tar[k])
          }
      }
  }
  defaultCampaign.click_url = click_url
  return defaultCampaign
}

/**
* 拼接notice_url，点击坐标宏上报拼接
* @param {object} defaultCampaign,campaign对象
* @param {object} clickPosition 点击坐标对象 ，包括x,y,scale
* @param {boolean} autoClick 是否为自动storekit
*/
export function setNoticeUrl(defaultCampaign, clickPosition, startPoint, autoClick, ctabanner) {
  let notice_url = defaultCampaign.notice_url;
  // 以下为所有点击坐标宏需要上报的参数，先删除，再重新拼接
  notice_url = delParam(defaultCampaign.notice_url, 'click_x');
  notice_url = delParam(notice_url, 'click_y');
  notice_url = delParam(notice_url, 'click_ori');
  notice_url = delParam(notice_url, 'click_senario');
  notice_url = delParam(notice_url, 'click_scale');
  notice_url = delParam(notice_url, 'webviewStartX');
  notice_url = delParam(notice_url, 'webviewStartY');
  notice_url = delParam(notice_url, 'webviewWidth');
  notice_url = delParam(notice_url, 'webviewHeight');
  notice_url = delParam(notice_url, 'endscreen_type');
  notice_url += `&webviewWidth=${document.body.clientWidth * clickPosition.scale}&webviewHeight=${document.body.clientHeight * clickPosition.scale}`;
  notice_url += `&webviewStartX=${startPoint.startX?Number(startPoint.startX):0}&webviewStartY=${startPoint.startY?Number(startPoint.startY):0}`;
  if (!autoClick) {//只有在不是自动storekit的情况下，拼接横纵坐标和方向
      let ori = checkScreenOrientation() === 'portrait' ? 1 : 2;
      notice_url += `&click_x=${parseInt(clickPosition.x)}&click_y=${parseInt(clickPosition.y)}&click_ori=${ori}`;
  }
  if (device().isAndroid) {//安卓额外拼接scale
      notice_url += '&click_scale=' + clickPosition.scale;
  }
  let isAutoClick = autoClick ? 2 : 0;//这个变量为了传click_senario
  notice_url += `&click_senario=${isAutoClick}`;//click_senario=0 表示不是自动点击，2 是自动点击，0 表示误点击
  // ctabanner的点击要拼接endscreen_type=3
  if (ctabanner) {
      notice_url += "&endscreen_type=3"
  }
  // install 逻辑目前是放在了 tpl1 中执行，所以大模板初始化的环境变量（是否扣回调，是否超时）在 tpl1 中目前是获取不到的，
  // notice_url 上报的 to cbt 逻辑不正确的问题，这个问题按目前的实现来看不好修，
  // 所以目前是针对 notice_url 这个字段不再额外拼接 to cbt 等 6 个参数
  // notice_url = appendBizParam(notice_url);

  defaultCampaign.notice_url = notice_url
  return defaultCampaign
}